import { httpClient } from '../../../../net/httpClient';
import UrlConfig from '../../../../net/UrlConfig';

import {
  ON_LICENSE_QUERY_INPUT_CHANGE,
  START_LOAD_LICENSE_EMPLOYEE_OPTIONS,
  LOAD_LICENSE_EMPLOYEE_OPTIONS_SUCCESS,
  LOAD_LICENSE_EMPLOYEE_OPTIONS_FAILURE,
  INIT_LOAD_LICENSE_EMPLOYEE_OPTIONS_ACTION_STATUS,
  START_LOAD_LICENSE_INFO,
  LOAD_LICENSE_INFO_SUCCESS,
  LOAD_LICENSE_INFO_FAILURE,
  INIT_LOAD_LICENSE_INFO_ACTION_STATUS,
  SELECT_LICENSE_INFO,
  OPEN_ADD_OR_EDIT_LICENSE_MODAL,
  ADD_OR_EDIT_LICENSE_CHANGE_INPUT,
  START_ADD_OR_EDIT_LICENSE,
  ADD_OR_EDIT_LICENSE_SUCCESS,
  ADD_OR_EDIT_LICENSE_FAILURE,
  INIT_ADD_OR_EDIT_LICENSE_ACTION_STATUS,
  RESET_ADD_OR_EDIT_LICENSE_MODAL,
  OPEN_DEL_LICENSE_MODAL,
  START_DEL_LICENSE,
  DEL_LICENSE_SUCCESS,
  DEL_LICENSE_FAILURE,
  INIT_DEL_LICENSE_ACTION_STATUS,
  RESET_DEL_LICENSE_MODAL,
  START_LOAD_LICENSE_NOTE,
  LOAD_LICENSE_NOTE_SUCCESS,
  LOAD_LICENSE_NOTE_FAILURE,
  INIT_LOAD_LICENSE_NOTE_ACTION_STATUS,
  LICENSE_NOTE_CHANGE_INPUT,
  START_ADD_OR_EDIT_LICENSE_NOTE,
  ADD_OR_EDIT_LICENSE_NOTE_SUCCESS,
  ADD_OR_EDIT_LICENSE_NOTE_FAILURE,
  INIT_ADD_OR_EDIT_LICENSE_NOTE_ACTION_STATUS,
  RESET_LICENSE_NOTE_MODAL,
} from './LicenseConstants';

export function onLicenseQueryInputChange({ name, value }) {
  return {
    type: ON_LICENSE_QUERY_INPUT_CHANGE,
    payload: { name, value },
  };
}

function startLoadLicenseEmployeeOptions() {
  return { type: START_LOAD_LICENSE_EMPLOYEE_OPTIONS };
}

export function loadLicenseEmployeeOptions(namePart = '') {
  return function(dispatch) {
    dispatch(startLoadLicenseEmployeeOptions());
    httpClient
      .get(UrlConfig.QUERY_LICENSE_EMPLOYEE_OPTIONS, { namePart })
      .then(resp => dispatch(loadLicenseEmployeeOptionsSuccess(resp)))
      .catch(err => dispatch(loadLicenseEmployeeOptionsFailure(err)));
  };
}

function loadLicenseEmployeeOptionsSuccess(resp) {
  return {
    type: LOAD_LICENSE_EMPLOYEE_OPTIONS_SUCCESS,
    payload: resp,
  };
}

function loadLicenseEmployeeOptionsFailure(err) {
  return {
    type: LOAD_LICENSE_EMPLOYEE_OPTIONS_FAILURE,
    payload: err,
  };
}

export function initLoadLicenseEmployeeOptionsActionStatus() {
  return {
    type: INIT_LOAD_LICENSE_EMPLOYEE_OPTIONS_ACTION_STATUS,
  };
}

function startLoadLicenseInfo() {
  return { type: START_LOAD_LICENSE_INFO };
}

export function loadLicenseInfo(params) {
  return function(dispatch) {
    dispatch(startLoadLicenseInfo());
    httpClient
      .get(UrlConfig.QUERY_LICENSE_LIST, params)
      .then(resp => dispatch(loadLicenseInfoSuccess(resp)))
      .catch(err => dispatch(loadLicenseInfoFailure(err)));
  };
}

function loadLicenseInfoSuccess(resp) {
  return {
    type: LOAD_LICENSE_INFO_SUCCESS,
    payload: resp,
  };
}

function loadLicenseInfoFailure(err) {
  return {
    type: LOAD_LICENSE_INFO_FAILURE,
    payload: err,
  };
}

export function initLoadLicenseInfoActionStatus() {
  return {
    type: INIT_LOAD_LICENSE_INFO_ACTION_STATUS,
  };
}

export function selectLicenseInfo(array) {
  return {
    type: SELECT_LICENSE_INFO,
    payload: array,
  };
}

export function openAddOrEditLicenseModal(mode, data) {
  return {
    type: OPEN_ADD_OR_EDIT_LICENSE_MODAL,
    payload: { mode, data },
  };
}

export function addOrEditLicenseChangeInput({ name, value }) {
  return {
    type: ADD_OR_EDIT_LICENSE_CHANGE_INPUT,
    payload: { name, value },
  };
}

function startAddOrEditLicense() {
  return {
    type: START_ADD_OR_EDIT_LICENSE,
  };
}

export function addOrEditLicense(params) {
  return function(dispatch) {
    dispatch(startAddOrEditLicense());
    httpClient
      .post(UrlConfig.ADD_OR_EDIT_LICENSE, params)
      .then(resp => dispatch(addOrEditLicenseSuccess(resp)))
      .catch(err => dispatch(addOrEditLicenseFailure(err)));
  };
}

function addOrEditLicenseSuccess(resp) {
  return {
    type: ADD_OR_EDIT_LICENSE_SUCCESS,
    payload: resp,
  };
}

function addOrEditLicenseFailure(err) {
  return {
    type: ADD_OR_EDIT_LICENSE_FAILURE,
    payload: err,
  };
}

export function initAddOrEditLicenseActionStatus() {
  return {
    type: INIT_ADD_OR_EDIT_LICENSE_ACTION_STATUS,
  };
}

export function resetAddOrEditLicenseModal() {
  return {
    type: RESET_ADD_OR_EDIT_LICENSE_MODAL,
  };
}

export function openDelLicenseModal(data) {
  return {
    type: OPEN_DEL_LICENSE_MODAL,
    payload: data,
  };
}

function startDelLicense() {
  return {
    type: START_DEL_LICENSE,
  };
}

export function delLicense(params) {
  return function(dispatch) {
    dispatch(startDelLicense());
    httpClient
      .post(UrlConfig.DELETE_LICENSE, params)
      .then(resp => dispatch(delLicenseSuccess(resp)))
      .catch(err => dispatch(delLicenseFailure(err)));
  };
}

function delLicenseSuccess(resp) {
  return {
    type: DEL_LICENSE_SUCCESS,
    payload: resp,
  };
}

function delLicenseFailure(err) {
  return {
    type: DEL_LICENSE_FAILURE,
    payload: err,
  };
}

export function initDelLicenseActionStatus() {
  return {
    type: INIT_DEL_LICENSE_ACTION_STATUS,
  };
}

export function resetDelLicenseModal() {
  return {
    type: RESET_DEL_LICENSE_MODAL,
  };
}

function startLoadLicenseNote() {
  return {
    type: START_LOAD_LICENSE_NOTE,
  };
}

export function loadLicenseNote() {
  return function(dispatch) {
    dispatch(startLoadLicenseNote());
    httpClient
      .get(UrlConfig.QUERY_LICENSE_NOTE_LIST)
      .then(resp => dispatch(loadLicenseNoteSuccess(resp)))
      .catch(err => dispatch(loadLicenseNoteFailure(err)));
  };
}

function loadLicenseNoteSuccess(resp) {
  return {
    type: LOAD_LICENSE_NOTE_SUCCESS,
    payload: resp,
  };
}

function loadLicenseNoteFailure(err) {
  return {
    type: LOAD_LICENSE_NOTE_FAILURE,
    payload: err,
  };
}

export function initLoadLicenseNoteActionStatus() {
  return {
    type: INIT_LOAD_LICENSE_NOTE_ACTION_STATUS,
  };
}

export function licenseNoteChangeInput({ name, value }) {
  return {
    type: LICENSE_NOTE_CHANGE_INPUT,
    payload: { name, value },
  };
}

function startAddOrEditLicenseNote() {
  return {
    type: START_ADD_OR_EDIT_LICENSE_NOTE,
  };
}

export function addOrEditLicenseNote(params) {
  return function(dispatch) {
    dispatch(startAddOrEditLicenseNote());
    httpClient
      .post(UrlConfig.ADD_OR_EDIT_LICENSE_NOTE, params)
      .then(resp => dispatch(addOrEditLicenseNoteSuccess(resp)))
      .catch(err => dispatch(addOrEditLicenseNoteFailure(err)));
  };
}

function addOrEditLicenseNoteSuccess(resp) {
  return {
    type: ADD_OR_EDIT_LICENSE_NOTE_SUCCESS,
    payload: resp,
  };
}

function addOrEditLicenseNoteFailure(err) {
  return {
    type: ADD_OR_EDIT_LICENSE_NOTE_FAILURE,
    payload: err,
  };
}

export function initAddOrEditLicenseNoteActionStatus() {
  return {
    type: INIT_ADD_OR_EDIT_LICENSE_NOTE_ACTION_STATUS,
  };
}

export function resetLicenseNoteModal() {
  return {
    type: RESET_LICENSE_NOTE_MODAL,
  };
}
